import * as React from 'react';

export interface ISimpleStickyProps extends React.HTMLProps<HTMLDivElement> {
  zIndex?: number;
  bottom?: string | number;
  top?: string | number;
  testId?: string;
}

export const SimpleSticky = React.forwardRef<HTMLDivElement, ISimpleStickyProps>((props, ref) => {
  const { children, zIndex, bottom, top, testId = 'simpleSticky' } = props;

  const style: React.CSSProperties = {
    position: 'sticky',
    zIndex,
    bottom,
    top,
  };

  return (
    <div ref={ref} style={style} data-testid={testId}>
      {children}
    </div>
  );
});

SimpleSticky.displayName = 'SimpleSticky';
